let TYPE = {
  INFO: 'info',
  LOG: 'log',
  ERROR: 'error',
  WARN: 'warn',
  ASSERT: 'assert',
}

export default TYPE
